var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isReady
    ? _c(
        "div",
        { attrs: { "data-page": "regions-add", "data-content-width": "wide" } },
        [
          _c(
            "md-dialog",
            {
              attrs: { "md-active": _vm.showRemoveConfirmation },
              on: {
                "update:mdActive": function ($event) {
                  _vm.showRemoveConfirmation = $event
                },
                "update:md-active": function ($event) {
                  _vm.showRemoveConfirmation = $event
                },
              },
            },
            [
              _c("md-dialog-title", [
                _vm._v(_vm._s(_vm.t("app-are-you-sure"))),
              ]),
              _vm._v(" "),
              _c("md-dialog-content", [
                _vm._v(
                  _vm._s(_vm.t("app-are-you-sure-you-want-to-delete")) + " "
                ),
                _c("i", [_vm._v(_vm._s(_vm.region.attributes.title))]),
                _vm._v(". "),
                _c("b", [_vm._v(_vm._s(_vm.t("app-cannot-be-undone")))]),
              ]),
              _vm._v(" "),
              _c(
                "md-dialog-actions",
                [
                  _c(
                    "md-button",
                    {
                      staticClass: "md-primary",
                      on: {
                        click: function ($event) {
                          _vm.showRemoveConfirmation = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.t("app-cancel")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "md-button",
                    {
                      staticClass: "md-primary",
                      on: {
                        click: function ($event) {
                          return _vm.remove()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.t("app-delete")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "page-header with-breadcrumbs typography" },
            [
              _c("h1", [_vm._v(_vm._s(_vm.title))]),
              _vm._v(" "),
              _c("breadcrumbs", { attrs: { trail: _vm.trail } }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "form",
            {
              staticClass: "standard-form-style",
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.save.apply(null, arguments)
                },
              },
            },
            [
              _vm.$route.params.id
                ? _c("div", { staticClass: "tabs" }, [
                    _c(
                      "button",
                      {
                        staticClass: "compact",
                        attrs: { type: "button" },
                        on: { click: _vm.onServiceAreasClick },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.t("app-service-areas")) +
                            "\n      "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "ui-form-row" },
                [
                  _c("app-input", {
                    attrs: {
                      name: "title-input",
                      required: "required",
                      type: "text",
                      label: "Title",
                    },
                    model: {
                      value: _vm.region.attributes.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.region.attributes, "title", $$v)
                      },
                      expression: "region.attributes.title",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "ui-form-row" },
                [
                  _c("legend", [_vm._v(_vm._s(_vm.t("app-administrators")))]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.onAddUser()
                        },
                      },
                    },
                    [
                      _c(
                        "button",
                        { staticClass: "compact", attrs: { type: "button" } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.t(
                                "app-add-organization-new-administrator-button"
                              )
                            )
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("add-user", {
                    ref: "add-user",
                    attrs: { entityId: _vm.$route.params.id, queue: "true" },
                    on: { change: _vm.onNewAdministrator },
                  }),
                  _vm._v(" "),
                  _c("fieldset", [
                    _c(
                      "div",
                      { staticClass: "md-style-scoped" },
                      [
                        _c("user-reference", {
                          attrs: { value: _vm.region.accounts },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "actions" }, [
                _vm.$route.params.id
                  ? _c(
                      "button",
                      {
                        staticClass: "danger",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            _vm.showRemoveConfirmation = true
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.t("app-delete")) +
                            "\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("button", { attrs: { type: "submit" } }, [
                  _vm._v(
                    "\n        " + _vm._s(_vm.t("app-submit")) + "\n      "
                  ),
                ]),
              ]),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }